import React, { useEffect, useRef, useState } from 'react';
import styles from './ProfileJobseekerView.module.css';
import Profile from '../../../components/UI/Common/Profile/Profile';
import ProfileTabButtons from '../../../components/UI/Common/ProfileTabButtons/ProfileTabButtons';
import { useSelector } from 'react-redux';
import { updateUser } from '../../../services/userService';
import EmployerProfileJobseekerViewBody from '../../../components/UI/Common/EmployerProfileJobseekerViewBody/EmployerProfileJobseekerViewBody';

function EmployerProfileJobseekerView({ jobseeker }) {
    const user = useSelector(state => state.user.user);
    const userToken = useSelector(state => state.user.token);
    const sectionRefs = {
        aboutMe: useRef(null),
        education: useRef(null),
        workExperience: useRef(null),
        certifications: useRef(null),
        portfolio: useRef(null),
        skills: useRef(null),
        workProficiency: useRef(null),
    };

    const scrollToSection = (section) => {
        sectionRefs[section]?.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };
    useEffect(() => {
        const formData = new FormData();
        formData.append('token', userToken); // Assuming you have user token
        if (user?.id && jobseeker?.id) {
            formData.append('profileOwnerId', jobseeker?.id); // Assuming you have user token
            formData.append('viewerId', user?.id); // Assuming you have user token
            updateUser(formData)
        }
    }, [jobseeker, user])
    const [activeTab, setActiveTab] = useState('')
    const [handleBlur, setHandleBlur] = useState(false)
     return (
        <div className={styles.container}>
            <Profile
                isEmployer={jobseeker?.employer_status && true}
                blur={handleBlur}
                handleBlur={handleBlur}
                setHandleBlur={setHandleBlur}
                jobseeker={jobseeker} />
            <ProfileTabButtons
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                handleBlur={handleBlur}
                setHandleBlur={setHandleBlur}
                isEmployer={jobseeker?.employer_status && true}
                blur={handleBlur}
                scrollToSection={scrollToSection}
            />
            <EmployerProfileJobseekerViewBody
                handleBlur={handleBlur}
                setHandleBlur={setHandleBlur}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                blur={handleBlur}
                employer={jobseeker}
                sectionRefs={sectionRefs} />
            {/* <Profile
                isEmployer={jobseeker?.company_name.length > 0 && true}
                blur={user?.verification_status === 'approved' ? false : user?.subscriptionStatus == 'active' ? false : true}
                jobseeker={jobseeker} />
            <ProfileTabButtons
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                isEmployer={jobseeker?.company_name.length > 0 && true}
                blur={user?.verification_status === 'approved' ? false : user?.subscriptionStatus == 'active' ? false : true} scrollToSection={scrollToSection} />
            <EmployerProfileJobseekerViewBody setActiveTab={setActiveTab} activeTab={activeTab} blur={user?.verification_status === 'approved' ? false : user?.subscriptionStatus == 'active' ? false : true} employer={jobseeker} sectionRefs={sectionRefs} /> */}
        </div>
    );
}

export default EmployerProfileJobseekerView;
